// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"707b9863","453":"ffda5e1a"}[chunkId] + ".chunk.js";
};